import { Article } from "../_/components/Article";
import { Ref } from "../_/components/Reference";

export const Fall = () => (
    <>
        <Article.Title>
            Determinacja
        </Article.Title>
        <Article.Body>
            Determinacja odzwierciedla stan psychiczny i motywację postaci w dążeniu do swoich celów. Każda postać rozpoczyna grę z maksymalną Determinacją wynoszącą 10 w przypadku kampanii i 3 w przypadku pojedyńczych sesji.

            Gdy postać:
            <ul>
                <li>zostanie pokonana w walce,</li>
                <li>poniesie spektakularną porażkę w istotnej dla siebie sprawie,</li>
                <li>podejmie decyzję sprzeczną ze swoimi wartościami,</li>
            </ul>
            należy sprawdzić, czy jej Determinacja spadnie. Prowadzący (Gap) powinien informować gracza, gdy jego działania mogą skutkować utratą Determinacji.

            Jeśli dojdzie do testu, wykonuje się rzut na Duszę z poziomem łatwości zależnym od aktualnej Determinacji:

            <ul>
                <li>10-7 - SŁ 4</li>
                <li> 6-4  - SŁ 3</li>
                <li> 3-2  - SŁ 2</li>
                <li> 1    - SŁ 1</li>
            </ul>
            Niepowodzenie testu oznacza utratę 1 punktu Determinacji. Jeśli postać straci swój ostatni punkt następuje jej Upadek.
        </Article.Body> 

        <Article.Title>
            Upadek
        </Article.Title>
        <Article.Body>
            Upadek to początek końca, historii postaci i nie jest to dobry koniec. Postać nie kończy gry natychmiast, zamiast tego 
            wspólnie z Gapiem ustalcie epilog dla postaci i ile sesji zajmię jego rozegranie. 
        </Article.Body>

        <Article.Title>
            Odzyskiwanie determinacji
        </Article.Title>
        <Article.Body>
            Postać, która staje naprzeciw własnym słabością odzyskuje wiarę w siebie i Determinację. 
            
            Odyskać determinację można na dwa sposoby:
            <ol>
                <li>Nagroda od Gapia - postać otrzymuje punkt Determinacji gdy zrealizuje ważne dla niej osiągnięcie </li>
                <li>Rozproszenie kości - raz na sesję, przed rzutem, gdy samodzielnie ustalasz źródła <Ref>Skupienia</Ref>, możesz dobrowolnie dodać także źródła <Ref>Rozproszenia</Ref>.
                    Jeśli Gap potwierdzi, że dana sytuacja może zregenerować Determinacje a test rozproszoną kością się powiedzie odzyskasz 1 punkt Determinacji. 
                </li>
            </ol>
            
        </Article.Body>

        <Article.Title>
            Niezdane rzuty
        </Article.Title>
        <Article.Body>
            Przed wykonaniem ważnego dla Ciebie rzutu, możesz zdecydować o jego automatycznym sukcesie. W takim przypadku musisz wykonać test na utratę Determinacji.
            Alternatywnie możesz podjąć tę decyzję już po rzucie, ale wtedy test na utratę Determinacji wykonujesz z rozproszeniem.

            Zasady wykorzystywania upadku podczas Testów grupowych <Ref>im więcej osób tym trudniej </Ref> znajdziej w poświeconym im <Ref>rodziale</Ref>.
        </Article.Body>
    </>
)